export function querySerializer(data: {
  [key: string]: string | number | boolean | undefined | null
}) {
  if (!data) return ''

  return Object.keys(data)
    .filter(
      (key) =>
        data[key] !== undefined &&
        data[key] !== undefined &&
        String(data[key]) !== '',
    )
    .map((key) => `${key}=${window.encodeURIComponent(String(data[key]))}`)
    .join('&')
}

export function queryParser<T = { [x: string]: string | number | boolean }>(
  params: URLSearchParams,
): T {
  const query = Object.fromEntries([...params])

  const typedQuery = Object.keys(query)
    .map((key) => {
      const value = query[key]

      let newValue
      if (value === 'true') newValue = true
      else if (value === 'false') newValue = false
      else if (!isNaN(Number(value))) newValue = Number(value)
      else newValue = value

      return { [key]: newValue }
    })
    .reduce((p, c) => ({ ...p, ...c }), {})

  return typedQuery as T
}
